// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2jYT_","modalFooterButton":"ModalNotes_modalFooterButton__3ovsh"};